import { Breadcrumbs, Link, Typography } from '@mui/material';
import { colors } from 'Constants/Colors';
import { useHistory } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface Props {
  items: BreadcrumbItem[];
}

const Breadcrumb = ({ items }: Props) => {
  const history = useHistory();

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast) {
          return (
            <Typography key={item.label} color={colors.GRAY_DARK} variant="subtitle1">
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={item.label}
            component="button"
            variant="body1"
            color={colors.GRAY_DARK}
            onClick={() => item.path && history.push(item.path)}
            sx={{
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
                cursor: 'pointer',
                color: colors.GRAY_DARK,
              },
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
